/**
 * 宿泊日ごとのCSV行に載せるオプションを、その行の宿泊日で絞り込む。
 *
 * 予約検索のCSVは部屋を日付単位で行分割するが、オプション配列は予約全体のまま渡ってくる。
 * 絞り込まないと2泊以上で全日程のオプションが各行に重複する。
 */

type OptionWithStayDate = {
	/** 日毎オプションの適用日。未設定なら予約全体に対するオプション */
	date?: string | null;
};

type ReservationWithOptions<T extends OptionWithStayDate> = {
	/** 予約のチェックイン日。日付なしオプションはこの日の行にだけ載せる */
	checkIn: string;
	option: Array<T>;
	optionCanceled: Array<T>;
};

type FilterOptionsByStayDateParams<T extends OptionWithStayDate> = {
	reservation: ReservationWithOptions<T>;
	/** そのCSV行の宿泊日 */
	stayDate: string;
};

export const filterOptionsByStayDate = <T extends OptionWithStayDate>({
	reservation,
	stayDate,
}: FilterOptionsByStayDateParams<T>): { options: Array<T>; canceledOptions: Array<T> } => {
	const isOnStayDate = (option: T): boolean => {
		if (option.date) {
			return option.date === stayDate;
		}
		return stayDate === reservation.checkIn;
	};
	return {
		options: reservation.option.filter(isOnStayDate),
		canceledOptions: reservation.optionCanceled.filter(isOnStayDate),
	};
};
